<template>
  <div class="record-detail-field">
    <p class="record-detail-field__label control-label">
      {{ label }}<span v-if="required" class="record-detail-field__required"> *</span>
    </p>
    <p class="record-detail-field__value">{{ value ?? '' }}</p>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], default: '' },
  required: { type: Boolean, default: false },
})
</script>

<style scoped lang="scss">
.record-detail-field {
  min-width: 0;

  &__label,
  &__value {
    margin: 0;
    overflow-wrap: anywhere;
  }

  &__value {
    min-height: 22px;
    color: var(--color-text-body);
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
  }

  &__required {
    color: var(--color-danger);
  }
}
</style>
